import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Component({
  selector: 'app-route-origin-destination-popup',
  templateUrl: './route-origin-destination-popup.component.html',
  styleUrls: ['./route-origin-destination-popup.component.scss']
})
export class RouteOriginDestinationPopupComponent implements OnInit {

  @Input() data: any;

  constructor(public utilityService: UtilityService) { }

  ngOnInit(): void {
  }

}
